import {Link} from 'react-router-dom';

const ErrorPage = () => {
    return (
        <>
            <div className="d-flex flex-column justify-content-center align-items-center vh-100 pb-7">
                <h1 className="display-1">
                    <span className="text-primary text-opacity-25">4</span>
                    <span className="text-warning text-opacity-25 opacity-75">0</span>
                    <span className="text-primary text-opacity-25">4</span>
                </h1>
                <h4 className="opacity-50 mb-5">Seems there is nothing here</h4>
                <Link to="/" className="btn btn-primary fs-lg fw-bolder fvs-expanded rounded-pill">Return Home</Link>
            </div>
        </>
    )
};

export default ErrorPage;
